import { NgModule } from '@angular/core';
import { AddColonPipe } from '@app/shared/pipes/add-colon.pipe';
import { CommaSeparatedPipe } from '@app/shared/pipes/comma-separated.pipe';
import { CommaSeparatedDatesPipe } from '@app/shared/pipes/comma-separated-dates.pipe';
import { DateRangePipe } from '@app/shared/pipes/date-range.pipe';
import { DateRangesPipe } from '@app/shared/pipes/date-ranges.pipe';
import { FormatDatePipe } from '@app/shared/pipes/format-date.pipe';
import { FormatTimePipe } from '@app/shared/pipes/format-time.pipe';
import { FormatXmlPipe } from '@app/shared/pipes/format-xml.pipe';
import { GroupByPipe } from '@app/shared/pipes/group-by-pipe';
import { OrderByPipe } from '@app/shared/pipes/order-by.pipe';
import { PrefixPipe } from '@app/shared/pipes/prefix.pipe';
import { SecuredResourceUrlPipe } from '@app/shared/pipes/secured-resource-url.pipe';
import { SuffixPipe } from '@app/shared/pipes/suffix.pipe';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { WrapInBracketsPipe } from '@app/shared/pipes/wrap-in-brackets.pipe';

@NgModule({
  declarations: [
    DateRangePipe,
    CommaSeparatedPipe,
    GroupByPipe,
    OrderByPipe,
    FormatTimePipe,
    WrapInBracketsPipe,
    FormatDatePipe,
    AddColonPipe,
    SuffixPipe,
    PrefixPipe,
    CommaSeparatedDatesPipe,
    DateRangesPipe,
    FormatXmlPipe,
    TranslatePipe,
    SecuredResourceUrlPipe
  ],
  exports: [
    DateRangePipe,
    CommaSeparatedPipe,
    GroupByPipe,
    OrderByPipe,
    FormatTimePipe,
    WrapInBracketsPipe,
    FormatDatePipe,
    AddColonPipe,
    SuffixPipe,
    PrefixPipe,
    CommaSeparatedDatesPipe,
    DateRangesPipe,
    FormatXmlPipe,
    TranslatePipe,
    SecuredResourceUrlPipe
  ]
})
export class PipesModule {
}
